import React from 'react';
import { MainLayout as MainLayoutComponent, MainLayoutContainer, MainLayoutProps, UpliftThemeProvider } from '@uplift/ui-v2';
import { useLayoutConf } from '../../hooks';
import { RestrictedAccessModal } from '../restricted-access-modal';

export type PatientMainLayoutProps = MainLayoutProps & {
  noTopPadding?: boolean;
  noContainerPadding?: boolean;
  containerClassName?: string;
};


export const MainLayout: React.FC<PatientMainLayoutProps> = ({ children, containerClassName, ...props }) => {
  const useConf = () => useLayoutConf();

  return (
    <UpliftThemeProvider>
      <MainLayoutComponent useLayoutConf={useConf} showAvatar={false} {...props}>
        <MainLayoutContainer noTopPadding={props.noTopPadding} noContainerPadding={props.noContainerPadding} className={containerClassName}>
          {children}
          <RestrictedAccessModal />
        </MainLayoutContainer>
      </MainLayoutComponent>
    </UpliftThemeProvider>
  );
};
